import "./App.scss";
import "bootstrap/dist/css/bootstrap.css";
import Navbar from "./components/navbar/Navbar";
import About from "./pages/about/About";
import Home from "./pages/home/Home";
import Resume from "./pages/resume/Resume";
import Portfolio from "./pages/portfolio/Portfolio";
import Contact from "./pages/contact/Contact";
import Footer from "./components/footer/Footer";
import GoToTop from "./components/gototop/GoToTop";
import React, { useEffect, useState } from "react";
import Loading from "./components/loading/Loading";

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  const style = {
    backgroundColor: "#000",
  };

  return (
    <div style={loading ? style : undefined}>
      {loading ? (
        <Loading loading={loading} />
      ) : (
        <>
          <Navbar />
          <Home />
          <About />
          <Resume />
          <Portfolio />
          <Contact />
          <Footer />
          <GoToTop />
        </>
      )}
    </div>
  );
}

export default App;
